/**
 * Created on 2017/07/11.
 * Controller for 我的账户-账单和余额菜单的结算单
 */
define('controllers/myaccount/dispute/account-disputeDetail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AccountDisputeDetailCtrl', ['$q', '$scope', '$state', '$stateParams','UserInfo', 'OpenTrade',
        function ($q, $scope, $state, $stateParams, UserInfo, OpenTrade) {
            /* 1. 局部变量声明 */
            var filterMap=JSON.parse($stateParams.dispute);
            var states = $state.current.name.split('.');
            var state = states[1];
            var billTypes = {
                disputeBillsDetail: 'AR',//应付-收益
                disputeEarningsDetail: 'AP' //应收-账单
            };

            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                constant: mainCons.earningsConstant,
                constants: mainCons.settlementConstant,
                billType: billTypes[state],
                businessType: mainCons.settlementConstant.businessType[billTypes[state]],
                disputeTypes: mainCons.settlementConstant.disputeReasonsMap[billTypes[state]]
            };

            // 保存勾选的争议单信息
            Model.disputeListAll = [];

            Model.query = {
                disputestatusMap: mainCons.settlementConstant.HistoryNodeInfo.dispute,
                businessType: {
                    selected: {typeCode: '-1', typeName: '全部'}
                }
            };

            $scope.queryFinshed=false;

            /* 3. $scope函数挂载 */
            $scope.goBack =goBack;
            $scope.queryList =queryList;

            /* 4. 初始化函数声明与执行 */
            $scope.queryList();


            function queryList() {
                $scope.dispute=JSON.parse($stateParams.dispute);
                var defer = $q.defer();
                var params = {};
                params.billType = billTypes[state];
                params.disputeStartTime="201001";
                params.disputeEndTime="211001";
                if (filterMap.billID) {
                    params.billID = filterMap.billID;
                }
                OpenTrade.getDispute({req: params}).then(function (resp) {
                    if (resp.retCode == 0&&resp.result) {
                        Model.disputeListAll = resp.result;
                        Model.disputeListAll.forEach(function (ele) {
                            if (ele.disputeID==filterMap.disputeID)  {
                                $scope.dispute= ele;
                                $scope.dispute.cpName = UserInfo.get().realName;
                                $scope.queryFinshed=true;
                                defer.resolve();
                            }
                        });
                    }

                    $scope.queryFinshed=true;
                    defer.resolve();
                }).catch(function (resp) {
                    $scope.queryFinshed=true;
                    defer.reject();
                });
                return defer.promise;

            }

            function goBack() {
                var url = billTypes[state] == 'AR' ? 'MyAccount.bills.dispute' : 'MyAccount.newEarnings.dispute';
                $state.go(url, {}, {reload: true});
            }
        }]);
});
